import moment from 'moment'

export default function (value) {
  if (value) {
    moment.locale('fr')
    return moment(String(value)).format('LL')
  }
}



// WEBPACK FOOTER //
// ./src/common/filters.js